export const environment =
{
  "production": true,
  "baseUrl": "https://aiq-acs-webapi-fms-be-aiq-uat-a8bpcfhndyc4dyfh.centralus-01.azurewebsites.net/",
  "onboardingUrl": "https://aiq-acs-webapi-fms-be-aiq-uat-a8bpcfhndyc4dyfh.centralus-01.azurewebsites.net/",
  "uiVresion": "1.0.09",
  "hosturl": "https://aiq-acs-webapi-fms-be-aiq-uat-a8bpcfhndyc4dyfh.centralus-01.azurewebsites.net/",
  "utilizationReportId": "ccafdbbc-0285-4f1f-8a62-3de99caeb5f5",
  "revenueReportId": "cf65b41f-40ba-4ec2-a7c2-00bc64420c55",
  "ClaimVsPaidReportId": "8b4acf35-a419-4e1a-992c-928b0655bb3f",
  "utilizationSummaryReportId": "0c5831f8-cce9-4701-b680-0ed879354731",
  "reportId": "1490276e-9e2f-4640-baa1-362cb1027704",
  "reportId835": "d977883a-4a69-47f6-b643-edb7c0158f21",
  "reportId837": "98a2f7e5-334b-4ec5-bfa6-1c6e181d232d",
  "APMServerURL": 'https://apmrum.allcaresoftware.com',
   "environment": 'uat',
}
